export default Object.freeze({
  EA_TO_CONSOLE_URL: '6.6.41',
  REPORTS_URL_UPDATE: '9.9.999', //Temporarily setting to far future release until feature is ready to be released
  SSO_FOR_THIRDPARTY_AUTH_USERS: '6.6.62',
  TOKEN_ATTACHED_TO_CONSOLE_URLS: '6.6.86',
});
